import { api } from "api";

export const getAnnouncements = (onBegin, onSuccess, onError) => {
  return async (dispatch) => {
    onBegin();
    await api
      .get("/api/announcements")
      .then((res) => {
        dispatch({
          type: "GET_ANNOUNCEMENTS_SUCCESS",
          payload: res.data.data.announcements,
        });

        onSuccess();
      })
      .catch((e) => {
        dispatch({
          type: "GET_ANNOUNCEMENTS_ERROR",
          payload: e,
        });
        onError(e);
      });
  };
};
